class Modal {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.activeModal = null; // Keep track of the active modal
    this.wasLocked = false;
    // this.pageOverlayElement = document.querySelector(".PageOverlay");

    this._attachListeners();
    this._checkOpenByHash();
  }

  _attachListeners() {
    this._closeListener = this._closeModal.bind(this);
    this._handleKeyboardListener = this._handleKeyboard.bind(this);

    this.domDelegate.on(
      "click",
      '[data-action="open-modal"]',
      this._openModalEvent.bind(this)
    );
    this.domDelegate.on(
      "click",
      '[data-action="close-modal"]',
      this._closeModal.bind(this)
    );
    document.body.addEventListener("modal:close", this._closeModal.bind(this));

    document.addEventListener("so.modal:open", (event) => {
      this._openModalEvent(event, event.detail.target);
    });

    document.addEventListener("so.modal:close", (event) => {
      this._closeModal(event, event.detail.target);
    });
  }

  _openModalEvent(event, target) {
    this._openModal(
      document.getElementById(target.getAttribute("aria-controls"))
    );
    event.preventDefault();
    event.stopPropagation();
  }

  _openModal(modal) {
    if (this.activeModal || !modal) {
      return; // If there is already an open modal, we return as we only allow one modal at a time
    }

    this.activeModal = modal;
    // this.domDelegate.on("keyup", this._handleKeyboardListener);

    if (document.documentElement.classList.contains("no-scroll")) {
      this.wasLocked = true;
    }

    // fastdom.mutate(() => {
    // });
    // Accessibility.clearTrapFocus(); // Needed as the modal can be open on top of a popover

    this._onTransitionEndedListener = this._onTransitionEnded.bind(this);
    this.activeModal.addEventListener(
      "transitionend",
      this._onTransitionEndedListener
    );

    this.activeModal.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("no-scroll");

    if (!this.activeModal.classList.contains("Modal--fullScreen")) {
      //   this.pageOverlayElement.classList.add("is-visible");
    }

    // this.pageOverlayElement.addEventListener("click", this._closeListener);

    window.SimpleCore._helpers.triggerEvent("modal:opened", {
      modal_id: this.activeModal.getAttribute("id"),
    });
  }

  _closeModal() {
    if (!this.activeModal) {
      return; // If no modal is open, we return immediately
    }

    this.activeModal.removeEventListener("keyup", this._handleKeyboardListener);
    // this.domDelegate.off("keyup");

    // fastdom.mutate(() => {
    // });
    if (this.activeModal.classList.contains("Modal--videoContent")) {
      this._resetVideoListener = this._resetVideo.bind(this);
      this.activeModal.addEventListener(
        "transitionend",
        this._resetVideoListener
      );
    }

    // Accessibility.removeTrapFocus(this.activeModal, "modal");
    // this.pageOverlayElement.classList.remove("is-visible");
    // this.pageOverlayElement.removeEventListener("click", this._closeListener);
    this.activeModal.setAttribute("aria-hidden", "true");

    window.SimpleCore._helpers.triggerEvent("modal:closed", {
      modal_id: this.activeModal.getAttribute("id"),
    });

    if (!this.wasLocked) {
      document.documentElement.classList.remove("no-scroll");
    }

    this.activeModal = null;
  }

  _onTransitionEnded(event) {
    if (event.propertyName !== "visibility") {
      return;
    }

    this.activeModal.removeEventListener(
      "transitionend",
      this._onTransitionEndedListener
    );
  }

  _resetVideo(event) {
    if (event.propertyName !== "visibility") {
      return;
    }

    const iframe = event.target.querySelector("iframe");
    iframe.parentNode.innerHTML = `<iframe class="Image--lazyLoad" data-src="${iframe.getAttribute(
      "data-src"
    )}" frameborder="0" allowfullscreen>`;
    event.target.removeEventListener("transitionend", this._resetVideoListener);
  }

  _checkOpenByHash() {
    const hash = window.location.hash;
    const modal = document.getElementById(hash.replace("#", ""));

    if (modal && modal.classList.contains("Modal")) {
      this._openModal(modal);
    }
  }

  _handleKeyboard(event) {
    if (this.activeModal !== null && event.keyCode === 27) {
      this._closeModal();
    }
  }
}
document.addEventListener("DOMContentLoaded", async function () {
  new Modal();
});
